import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=093bc724&scoped=true"
import script from "./menu-list.vue?vue&type=script&lang=js"
export * from "./menu-list.vue?vue&type=script&lang=js"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=093bc724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093bc724",
  null
  
)

export default component.exports